export default class TopBar {
    constructor() {
        const _this = this;
        const el: HTMLElement = document.querySelector('.container-post-processing');
        if (!el) {
            return;
        }
        const eY = el.getBoundingClientRect().top;
        document.addEventListener('scroll', () => {
            _this.scrollTop(el, eY);
        });
        _this.scrollTop(el, eY);
        // eine folgende bar benötigt 1em margin top
        let prevEl : HTMLElement = <HTMLElement>el.parentElement.previousElementSibling;
        if (prevEl && prevEl.classList.contains('bar-text')) {
            prevEl.style.marginTop = '1em';
        }
    }

    scrollTop(el: HTMLElement, eY: number) {
        let barTop = eY - window.scrollY < 0 ? 0 : eY - window.scrollY;
        el.style.top = barTop + 'px';
    }
}
